import FadedText from "@components/FadedText";
import { AltText, Column, LineClamp, Row } from "@components/Layout";
import type { PlayableTrackProps } from "@components/PlayableTrack/types";
import { Template } from "@components/Template";
import { Image } from "@kobalte/core";
import { formatPlayTime } from "@src/app/utils";
import { BsDot } from "solid-icons/bs";
import type { VoidComponent } from "solid-js";
import { MobileTrackWrapper, TrackImage } from "./styled";

const MobileTrack: VoidComponent<Omit<PlayableTrackProps, "even">> = (props) => {
	return (
		<MobileTrackWrapper padding="16px" gap="10px" onclick={props.onPlay}>
			<TrackImage onclick={props.onImageClick}>
				<Image.Img src={props.track.photo} />
				<Image.Fallback>
					<Template w="100%" h="100%" />
				</Image.Fallback>
			</TrackImage>
			<Column>
				<h4 class={LineClamp}>{props.track.name}</h4>
				<Row alignItems="center" maxWidth="200px">
					<FadedText fontSize="12px" class={LineClamp} style={{ width: "max-content" }}>
						{props.track.author.nickname}
					</FadedText>
					<AltText lineHeight={0}>
						<BsDot />
					</AltText>
					<FadedText fontSize="12px" style={{ width: "max-content", "white-space": "nowrap" }}>
						{formatPlayTime(props.track.length, {
							s: true,
						})}
					</FadedText>
				</Row>
			</Column>
		</MobileTrackWrapper>
	);
};
export default MobileTrack;
